import API from "@utils/plugins/API";

const EnergySourceService = {
  all: (params) => {
    return API.get("energy-sources", { params: params });
  },
  create: (name, name_eng, description) => {
    return API.post("energy-sources", {
      name,
      name_eng,
      description,
    });
  },
  update: (id, name, name_eng, description) => {
    return API.put(`energy-sources/${id}`, {
      name,
      name_eng,
      description,
    });
  },
  find: (id) => {
    return API.get(`energy-sources/${id}`);
  },
  destroy: (id) => {
    return API.delete(`energy-sources/${id}`);
  },
};

export default EnergySourceService;
